/* eslint-disable @typescript-eslint/no-explicit-any */
import {useEffect, useState} from 'react';
import {
  defaultErrorValues,
  showErrorValuesDefault,
  showErrorValuesSubmit,
} from '../../data/constants/Assurance/assuranceScolaire';
import {thousandSeparator} from '../../data/factory';
import {IError} from '../../data/types/interface/Assurance/assuranceScolaire';

export const useForm = (
  data: any,
  Validate: any,
  handleCancel: any,
  handleSave: any,
  listAgence?: any,
  prime?: any,
) => {
  const [values, setValues] = useState(data);
  const [dto, setDto] = useState({error: true, data});
  const [showErrors, setShowErrors] = useState(showErrorValuesDefault);
  const [errors, setErrors] = useState<IError>(defaultErrorValues);

  const handleChange = (name: string, value: any, fired: boolean) => {
    setShowErrors({...showErrors, [name]: value !== fired});
    let primeTTC = '';
    if (name === 'dateNaissanceEleveAssure') {
      const _agePortal = 12;
      const minDate = new Date();
      minDate.setFullYear(new Date().getFullYear() - _agePortal);

      if (value > minDate) {
        primeTTC = thousandSeparator(prime.moinsDouze, ' ');
      } else {
        primeTTC = thousandSeparator(prime.plusDouze, ' ');
      }
    }
    setValues({
      ...values,
      [name]: value,
      primeTTC: primeTTC !== '' ? primeTTC : values.primeTTC,
    });
  };

  const noError = () => {
    let bNoError = true;
    Object.values(errors).forEach(element => {
      if (element !== '') {
        bNoError = false;
      }
    });
    return bNoError;
  };

  const handleSubmit = () => {
    setShowErrors(showErrorValuesSubmit);
    const errors = Validate(values, listAgence);
    console.log(errors, showErrorValuesSubmit);

    setErrors(errors);
    if (noError()) {
      setDto({error: false, data: values});
    } else {
      setDto({error: true, data: {}});
    }
  };

  useEffect(() => {
    setErrors(Validate(values, listAgence));
  }, [values]);

  useEffect(() => {
    if (!dto.error) {
      handleSave();
    }
  }, [dto]);

  return {handleChange, handleSubmit, values, errors, showErrors, dto};
};
